import React, { Component } from 'react';
import $ from 'jquery';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-google'

class Signup2 extends Component {
  constructor() {
    super();
    this.state = {
      fields: {},
      errors: {},
      recaptchaVerified: false
    }
  };

  componentDidMount() {
    if (this.props.history.location.state === undefined) {
      this.props.history.push('/signup/step1')
    }

    loadReCaptcha();

    if (this.captcha) {
      this.captcha.reset();
    }
  }

  onLoadRecaptcha = () => {
    if (this.captcha) {
      this.captcha.reset();
    }
  }

  verifyCallback = (response) => {
    var loginController = this;
    $.ajax({
      url: "/api/verify-recaptcha",
      type: 'POST',
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      data: { "response": response },
      async: false,
      contentType: false,
      success: function (res) {
        if (res.success) {
          loginController.state.recaptchaVerified = true;
          loginController.setState(loginController.state);
        } else {
          loginController.captcha.reset();
        }
      }
    });
  }

  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
  }

  submituserRegistrationForm = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      if (this.state.recaptchaVerified) {
        var signupdata = this.props.location.state.signup1data;
        signupdata["mobileNumber"] = this.state.fields.mobilenum;
        signupdata["organizationName"] = this.state.fields.orgname;
        signupdata["address"] = this.state.fields.address;
        this.signup(signupdata);
      }
    }
  }
  clearCookie() {
    //Clear Cookies
    var allCookies = document.cookie.split(';');
    for (var i = 0; i < allCookies.length; i++) {
      document.cookie = allCookies[i] + "=;expires="
        + new Date(0).toUTCString();
    }
  }
  signup(signupdata) {
    let errors = {};
    let SignUpController = this;
    SignUpController.clearCookie();
    $.ajax({
      url: "/api/sign-up-user",
      type: 'POST',
      async: false,
      headers: {
        "Content-type": "application/json"
      },
      data: JSON.stringify(signupdata),
      success: function (res) {
        if (res.success === true) {
          SignUpController.props.history.push({
            pathname: '/signup/otpverification',
            state: { signupdata: signupdata }
          });
        } else {
          errors["response"] = res.result;
          SignUpController.setState({
            errors: errors
          });
        }
      }
    });
  }

  validateMobNum = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["mobilenum"]) {
      errors["mobilenum"] = "*Please enter your mobile number"
    }

    this.setState({
      errors: errors
    });
  }

  validateOrgName = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["orgname"]) {
      errors["orgname"] = "*Please enter your organisation name";
    }

    this.setState({
      errors: errors
    });
  }

  validateAddress = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["address"]) {
      errors["address"] = "*Please enter your address";
    }

    this.setState({
      errors: errors
    });
  }

  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["mobilenum"]) {
      formIsValid = false;
      errors["mobilenum"] = "*Please enter your mobile number"

    }

    if (!fields["orgname"]) {
      formIsValid = false;
      errors["orgname"] = "*Please enter your organisation name";
    }

    if (!fields["address"]) {
      formIsValid = false;
      errors["address"] = "*Please enter your address";
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  render() {
    return (
      <div className="wrapper">
        <form method="post">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg-12 p-0">
                <div className="card sign-in-right-tab">
                  <div className="card-body sign-in-page">
                    <div className="col-sm-12">
                      <div className="logoBox mb-2">
                        <img src="./assets/images/dheeai.png" alt="" />
                        <h5 className="signinTitle">Create a Developer Account</h5>
                        <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                      </div>
                    </div>
                    <div className="col-9 p-0 mx-auto ">
                      <div className="form-group">
                        <div className="step1to3">Step 2 of 3</div>
                        <div className="crplan mt-1">Set up your credentials</div><br />

                        <div className="input-group mb-3">
                          <input type="tel" className="form-control" name="mobilenum" onBlur={this.validateMobNum} onChange={this.handleChange} placeholder="Mobile Number with country code (e.g. 919999988888) *" />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.mobilenum}</div>
                        </div>

                        <div className="input-group mb-3">
                          <input type="text" className="form-control" name="orgname" onBlur={this.validateOrgName} onChange={this.handleChange} placeholder="Organisation name *" />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.orgname}</div>
                        </div>

                        <div className="input-group mb-3">
                          <input type="text" className="form-control" name="address" onBlur={this.validateAddress} onChange={this.handleChange} placeholder="Address *" />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.address}</div>
                        </div>
                      </div>
                      <br /><br />

                      <ReCaptcha
                        ref={(el) => { this.captcha = el; }}
                        render="explicit"
                        sitekey="6Lda-PoUAAAAAJcNRvLXI827ygaCcUIqA5r-wefu"
                        onloadCallback={this.onLoadRecaptcha}
                        verifyCallback={this.verifyCallback}
                      /><br /><br />

                      <button type="button" value="Submit" className="btn btn-primary btn-block" onClick={this.submituserRegistrationForm}>Proceed</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <script src="plugins/jquery/jquery.min.js"></script>
        <script src="plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
        <script src="assets/js/adminlte.js"></script>
      </div>
    );
  }
}

export default Signup2;



// WEBPACK FOOTER //
// ./src/sales-desk/signup/Signup2.js